<div class="modal-content">
  <div class="modal-header">
    <h1 class="modal-title pull-left" id="my-modal-title">{{ title | globalTranslate }}</h1>
    <button type="button" class="btn-close pull-right" [attr.aria-label]="'CLOSE' | globalTranslate" (click)="onCancel()">
      <img src="../../assets/images/⚛️ icons-close-circle-outline.svg" alt="close-icon" />
    </button>
  </div>
  <div class="modal-body">
      <div class="static-text"> {{'RIDP_CALLCENTER_STATIC18' | globalTranslate }}
       <div class="ridp-expanded-content">
            <div class="primary_doc_section">
              <h2 class="section-header">{{'RIDP_PRIMARY_DOC_HEADER' | globalTranslate}}</h2>
             <p [innerHTML]="'RIDP_PRIMARY_DOC_TEXT' | globalTranslate"></p>
             <p [innerHTML]="'RIDP_PRIMARY_DOC_TEXT_02' | globalTranslate"></p>
             <p class="primary_doc_list pt-3">{{'RIDP_PRIMARY_DOC_LIST_01' | globalTranslate}}</p>
             <p class="primary_doc_list">{{'RIDP_PRIMARY_DOC_LIST_02' | globalTranslate}}</p>
              <ul class="doc-list" role="list">
                <li role="listitem" [innerHTML]="'RIDP_PRIMARY_DOC_LIST_03' | globalTranslate"></li>
                <li role="listitem">{{'RIDP_PRIMARY_DOC_LIST_04' | globalTranslate}}</li>
                <li role="listitem">{{'RIDP_PRIMARY_DOC_LIST_05' | globalTranslate}}</li>
                <li role="listitem">{{'RIDP_PRIMARY_DOC_LIST_06' | globalTranslate}}</li>
                <li role="listitem">{{'RIDP_PRIMARY_DOC_LIST_07' | globalTranslate}}</li>
                <li role="listitem">{{'RIDP_PRIMARY_DOC_LIST_08' | globalTranslate}}</li>
                <li role="listitem">{{'RIDP_PRIMARY_DOC_LIST_09' | globalTranslate}}</li>
              </ul>
              <p class="primary_doc_list">{{'RIDP_PRIMARY_DOC_LIST_10' | globalTranslate }}</p>
              <p class="primary_doc_list">{{'RIDP_PRIMARY_DOC_LIST_11' | globalTranslate }}</p>
              <p class="primary_doc_list">{{'RIDP_PRIMARY_DOC_LIST_12' | globalTranslate }}</p>
              <ul class="doc-list" role="list">
                <li role="listitem">{{'RIDP_PRIMARY_DOC_LIST_13' | globalTranslate}}</li>
                <li role="listitem">{{'RIDP_PRIMARY_DOC_LIST_14' | globalTranslate}}</li>
              </ul>
             <p class="pt-3" [innerHTML]="'RIDP_WRITTEN_ATTESTATION_NOTE' | globalTranslate"></p>
             <ul class="doc-list" role="list" id="written-statement">
                <li role="listitem">{{'RIDP_WRITTEN_ATTESTATION_EXAMPLES' | globalTranslate}}</li>
                <li role="listitem">{{'RIDP_WRITTEN_ATTESTATION_EXAMPLES_02' | globalTranslate}}</li>
                <li role="listitem">{{'RIDP_WRITTEN_ATTESTATION_EXAMPLES_03' | globalTranslate}}</li>
                <li role="listitem">{{'RIDP_WRITTEN_ATTESTATION_EXAMPLES_04' | globalTranslate}}</li>
            </ul>
            <hr>
            <div class="supporting_doc">
              <h3 class="section-header">{{'RIDP_SUPPORTING_DOC_HEADER' | globalTranslate}}</h3>
              <p [innerHTML]="'RIDP_SUPPORTING_DOC_TEXT' | globalTranslate"></p>
               <ul class="doc-list" role="list">
                <li role="listitem">{{'RIDP_SUPPORTING_DOC_LIST_01' | globalTranslate}}</li>
                <li role="listitem">{{'RIDP_SUPPORTING_DOC_LIST_02' | globalTranslate}}</li>
                <li role="listitem">{{getSupportingPaystubOverride() || ('RIDP_SUPPORTING_DOC_LIST_03' | globalTranslate)}}</li>
                <li role="listitem">{{'RIDP_SUPPORTING_DOC_LIST_04' | globalTranslate}}</li>
                <li role="listitem" [innerHTML]="'RIDP_SUPPORTING_DOC_LIST_05' | globalTranslate"></li>
              </ul>
            </div>
            </div>
          </div>
      <br>
    </div>
  </div>